export const pluralize = (count: number, singular: string, plural?: string) => {
  const label = count === 1 ? singular : (plural ?? `${singular}s`)
  return label
}
